import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ImportedDevicesComponent } from './imported-devices/imported-devices.component';

const routes: Routes = [
  {
    path: '',
    component: ImportedDevicesComponent,
    data: {
      title: 'Import Devices',
      urls: [{ title: 'Dashboard', url: '/' }, { title: 'Import Devices' }],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ImportDeviceRoutingModule {}
